<template>
  <div id="app">
    <Head v-if="tabName != '登录'" @labelName="labelName"></Head>
    <router-view />
    <Hooter v-if="tabName != '登录'"></Hooter>
    <SlideBar v-if="tabName != '登录'" id="content4"></SlideBar>
    <a ref="backer" id="backer" class="backer" href="#">
      <img src="./assets/ding.png" />
    </a>
  </div>
</template>
<script>
import Head from "./components/head.vue";
import Hooter from "./components/footer.vue";
import SlideBar from "./components/sidebar.vue";
export default {
  components: {
    Head,
    Hooter,
    SlideBar,
  },
  name: "IndexHome",
  data() {
    return {
      tabName: "首页",
    };
  },
  methods: {
    labelName(name) {
      this.tabName = name;
      console.log("子组件传递过来的值", name);
    },
  },
  watch: {
    $route(to, from) {
      switch (to.path) {
        case "/home":
          this.tabName = "首页";
          break;
        case "/cooperation":
          this.tabName = "合作案例";
          break;
        case "/equipment":
          this.tabName = "设备";
          break;
        case "/about":
          this.tabName = "关于我们";
          break;
        default:
          break;
      }
      // console.log(to);
      // console.log(from);
    },
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      if (top > 600) {
        document.getElementById("backer").style = "display:flex";
        this.$refs.backer.classList.add("animate__backInUp");
        this.$refs.backer.classList.add("animate__animated");
      } else {
        document.getElementById("backer").style = "display:none";
      }
    });
  },
};
</script>

<style>
*:not(input) {
  user-select: none;
  margin: 0;
  padding: 0;
  border: none;
  font-weight: 400;
  flex: none;
  box-sizing: border-box;
}

button {
  text-align: center;
  border: none;
}

/* 滚动条自定义设置 */
::-webkit-scrollbar {
  width: 10px;
  height: 1px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #bab9b9;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #EDEDED;
}

.el-carousel__container {
  /* height: 29.3125rem !important; */
  height: 90% !important;
  overflow: hidden !important;
}

.el-tabs--border-card>.el-tabs__header {
  background: none !important;
  border-bottom: none !important;
}

.el-carousel__button {
  width: 10px !important;
  height: 10px !important;
  border: 2px solid #EEEEEE !important;
}

.el-carousel__indicators--outside button {
  background: #0E6EB8 !important;
}
.el-tabs__header.is-right{
  border-left: none !important;
}
html {
  font-size: 1.1vw;
  font-family: Source Han Sans SC;
}

@media screen and (max-width: 900px) {
  .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    padding: 0 20px !important;
  }
}


@media screen and (max-width: 600px) {

  html,
  body {
    width: 100vw;
    font-size: 1.26666666667vw !important;
  }
  .el-tabs__header.is-right{
    width: 100% !important;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item{
    height: 100% !important;
    width: 100% !important;
    margin: 0 !important;
  }
  .home_content,.about{
    margin-top: 70px;
  }
  .head {
    display: none !important;
  }

  .head_h5 {
    display: block !important;
  }
  .carousel_img {
    padding: 16px !important;

  }

  .el-col-7,
  .el-col-1,
  .el-col-13,
  .el-col-10,
  .el-col-4,
  .el-col-16,
  .el-col-19 {
    width: 100% !important;
  }

  .product_con>div,
  .us_con>div,.introduce_con>div {
    flex-flow: column;
  }

  .cooperation_you,
  .us_you,
  .service_you,
  .product_you {
    margin-top: 26px;
  }

  .product_zuo>div:first-child>div:first-child>div:nth-child(2),
  .us_zuo>div:nth-child(2) {
    margin-top: 6px;
  }

  .product_you,
  .us_you,.business_list {
    grid-template-rows: repeat(3, 1fr) !important;
    grid-template-columns: repeat(2, 1fr) !important;
  }
  .business_item > div{
    line-height: 2.525rem !important;
    width: 86% !important;
  }
  .us_you>div>div>div>div:nth-child(3),
  .product_you>div>div>div>div:nth-child(2) {
    line-height: 13px !important;
  }
  .el-carousel__arrow{
    width: 16px !important;
    height: 16px !important;
  }
  .service_zhan,.service_hover{
    height: 41.3125rem !important;
  }
  .service_hover{
    width: 30rem !important;
  }
  .carousel_you,.carousel_you1{
    height: 47.3125rem !important;
  }
  .service_hover > div{
    line-height: 2.625rem !important;
  }
  .service_zhan{
    min-width: 15rem !important;
  }
  .productFz{
    display: block !important;
  }
  .productYs{
    display: none !important;
  }
  .bg{
    padding: 1rem 0 2.5rem 0 !important;
  }
  .product_zuo{
    margin-left: 7.5rem !important;
  }
  .footer {
    padding: 20px !important;
    height: 100% !important;
  }

  .footer_con {
    flex-flow: column;
  }

  .footer_con>img {
    /* width: 100% !important; */
    margin-top: 20px;
  }

  .footer_di {
    margin-bottom: 26px;
  }
}

html,
body {
  scroll-behavior: smooth;
}

.backer {
  position: fixed;
  right: 30px;
  bottom: 60px;
  display: none;
  flex-flow: column;
  z-index: 9999;
  cursor: pointer;
}

.backer > img {
  width: 42px;
  height: 42px;
  border-radius: 50%;
}

#app{
  /* font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale */
  font-family: Source Han Sans SC;
}
</style>
